import groq from "groq";

export const OfficeListQuery = groq`
  *[_type == "office" && enabled == true] | order(officeID asc) {
    officeID,
    locationName
  }
`;

export const OfficeQuery = groq`
  *[_type == "office" && 
    urlSlug == $slug && 
    enabled == true][0]{
    _type,
    _id,
    locationName,
    officeID,
    urlSlug,
    enabled,
    phone,
    phoneAlt,
    acceptSpanishOnlyApplications,
    spanishHiringLink,
    usesAugusta,
    onCarePlatform,
    useChatbot,
    address,
    "stateProvince": address.stateProvince,
    areaServed,
    geoCoordinates,
    officeServices[]{
      ...,
      "service": service->{
        ...,
        "iconData": icon {
          ...,
          "url": asset->url,
          "altText": asset->altText,
          "metadata": asset->metadata.dimensions
        }
      }
    },
    officeRating,
    "socialMediaUrls": socialMediaLinks[].url,
    "franchiseNumber": *[_type == "franchiseOrganization" && references(^._id)][0].number
  }
`;

export const OfficeByIdQuery = groq`
  *[_type == "office" && officeID == $officeID && enabled == true][0]{
    _type,
    _id,
    "_ref": null,
    locationName,
    officeID,
    urlSlug,
    enabled,
    phone,
    phoneAlt,
    seoCityAlias,
    marketingRegionAlias,
    stateLicense,
    useChatbot,
    address{
      _type,
      name,
      addressLine1,
      addressLine2,
      city,
      stateProvince,
      country,
      postalCode
    },
    areaServed,
    officeRating,
    "facebookUrl": socialMediaLinks[platform->name == "Facebook"][0].url,
    "franchiseNumber": *[_type == "franchiseOrganization" && ^._id in offices[]._ref][0].number,
    "franchiseOrganization": *[_type == "franchiseOrganization" && ^._id in offices[]._ref][0]{
      foundingYear
    }
  }
`;
